import { Box } from "theme-ui";

export default function InfoIcon({ strokeOverride = "#009CDA", ...props }) {
  return (
    <Box
      as="svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13" cy="13" r="12" stroke={strokeOverride} strokeWidth="2" />
      <path d="M13 11V19M13 9V7" stroke={strokeOverride} strokeWidth="2" />
    </Box>
  );
}
